import PropTypes from 'prop-types';
import { FadeInAnimation } from '../../shared';
import useResponsive  from '../../../../utils/responsive';

const DownloadAppSection = (props) => {    
    
    const {isMobile} = useResponsive();

    return (

        <FadeInAnimation>

            <div className={isMobile ? 'download-app-section-content-container' : 'container-root download-app-section-content-container'}
                style={{
                    marginTop: -1 * props.offsetHeight + 140
                 }}>

                <h2 className='mobile-app-section-title'>{props.title}</h2>

                <p className='download-app-section-paragraph'>{props.paragraph}</p>

                <div>
                    <a
                        href="//play.google.com/store/apps/details?id=za.co.homii.mobile&hl=en"
                        rel="noreferrer"
                        target="_blank"
                    >
                        <img
                            src="/assets/images/google_play_black.png"
                            alt="Google Play"
                            className="app-download-buttons"
                        />
                    </a>

                    <a
                        href="//apps.apple.com/za/app/homii-lifestyle/id1478894335"
                        rel="noreferrer"
                        target="_blank"
                    >
                        <img
                            src="/assets/images/apple_black.png"
                            alt="Play Store"
                            className="app-download-buttons"
                        />
                    </a>
                    <a
                        href="//appgallery.huawei.com/#/app/C102716343"
                        rel="noreferrer"
                        target="_blank"
                    >
                        <img
                            src="/assets/images/huawei_black.png"
                            alt="Huawei Store"
                            className="app-download-buttons"
                        />
                    </a>
                </div>

            </div>

        </FadeInAnimation>

    );
};

export default DownloadAppSection;

DownloadAppSection.propTypes = {
    title: PropTypes.string,
    paragraph: PropTypes.string,
    offsetHeight: PropTypes.number,
};

